export default "__VITE_ASSET__nKpl0Wd$__"